module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-contract-79398011.svg";